/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Toast_Preparing_DownloadInputs */



/**
* | output |
* | --- |
* | "Preparing download..." |
*
* @param {Spaces_Toast_Preparing_DownloadInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_toast_preparing_download = /** @type {((inputs?: Spaces_Toast_Preparing_DownloadInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Toast_Preparing_DownloadInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Download wird vorbereitet...")
	return /** @type {LocalizedString} */ ("Preparing download...")
});